export const atmLimit = require("../../../../assets/svg/ATM Limit.svg");
export const aboutUTGL = require("../../../../assets/svg/About UTGL.svg");
export const accountAsset = require("../../../../assets/svg/Account Asset.svg");
export const accountBalance = require("../../../../assets/svg/Account Balance.svg");
export const accountCenterWeb = require("../../../../assets/svg/Account Center Web.svg");
export const accountCenter = require("../../../../assets/svg/Account Center.svg");
export const accountClosed = require("../../../../assets/svg/Account Closed.svg");
export const accountPending = require("../../../../assets/svg/Account Pending.svg");
export const accountProfile = require("../../../../assets/svg/Account Profile.svg");
export const accountSuspended = require("../../../../assets/svg/Account Suspended.svg");
export const accountUpgrade = require("../../../../assets/svg/Account Upgrade.svg");
export const account = require("../../../../assets/svg/Account.svg");
export const accountsActive = require("../../../../assets/svg/Accounts Active.svg");
export const accountsInactive = require("../../../../assets/svg/Accounts Inactive.svg");
export const acquisition = require("../../../../assets/svg/Acquisition.svg");
export const acquisitionbp = require("../../../../assets/svg/AcquisitionBP.svg");
export const activityActive = require("../../../../assets/svg/Activity Active.svg");
export const activityHistoryDatePicker = require("../../../../assets/svg/Activity History Date Picker.svg");
export const activityHistoryFilter = require("../../../../assets/svg/Activity History Filter.svg");
export const activityInactive = require("../../../../assets/svg/Activity Inactive.svg");
export const addAccount = require("../../../../assets/svg/Add Account.svg");
export const addAsset = require("../../../../assets/svg/Add Asset.svg");
export const addCard = require("../../../../assets/svg/Add Card.svg");
export const addPayee = require("../../../../assets/svg/Add Payee.svg");
export const add = require("../../../../assets/svg/Add.svg");
export const address80 = require("../../../../assets/svg/Address 80.svg");
export const address = require("../../../../assets/svg/Address.svg");
export const alertDanger = require("../../../../assets/svg/Alert Danger.svg");
export const alertWarning = require("../../../../assets/svg/Alert Warning.svg");
export const appSettings = require("../../../../assets/svg/App Settings.svg");
export const applePay = require("../../../../assets/svg/Apple Pay.svg");
export const arrowDownCircle = require("../../../../assets/svg/Arrow Down Circle.svg");
export const arrowDownMenu = require("../../../../assets/svg/Arrow Down Menu.svg");
export const arrowDownPoint = require("../../../../assets/svg/Arrow Down Point.svg");
export const arrowDown = require("../../../../assets/svg/Arrow Down.svg");
export const arrowLeftCircle = require("../../../../assets/svg/Arrow Left Circle.svg");
export const arrowLeft = require("../../../../assets/svg/Arrow Left.svg");
export const arrowRightCircle = require("../../../../assets/svg/Arrow Right Circle.svg");
export const arrowRightOrangeCircle = require("../../../../assets/svg/Arrow Right Orange Circle.svg");
export const arrowRightOrange = require("../../../../assets/svg/Arrow Right Orange.svg");
export const arrowRight = require("../../../../assets/svg/Arrow Right.svg");
export const arrowUpCircle = require("../../../../assets/svg/Arrow Up Circle.svg");
export const arrowUpPoint = require("../../../../assets/svg/Arrow Up Point.svg");
export const arrowUp = require("../../../../assets/svg/Arrow Up.svg");
export const assetCustody = require("../../../../assets/svg/Asset Custody.svg");
export const autoRenewalDisabled = require("../../../../assets/svg/Auto Renewal Disabled.svg");
export const autoRenewalEnabled = require("../../../../assets/svg/Auto Renewal Enabled.svg");
export const bnb = require("../../../../assets/svg/BNB.svg");
export const btc = require("../../../../assets/svg/BTC.svg");
export const barGraph = require("../../../../assets/svg/Bar Graph.svg");
export const billPayment = require("../../../../assets/svg/Bill Payment.svg");
export const billpaymentsuccess = require("../../../../assets/svg/BillPaymentSuccess.svg");
export const binancebrokerbanner = require("../../../../assets/svg/BinanceBrokerBanner.svg");
export const biometric = require("../../../../assets/svg/Biometric.svg");
export const bitfinexbrokerbanner = require("../../../../assets/svg/BitfinexBrokerBanner.svg");
export const businessCard = require("../../../../assets/svg/Business Card.svg");
export const cad = require("../../../../assets/svg/CAD.svg");
export const cs = require("../../../../assets/svg/CS.svg");
export const calendar = require("../../../../assets/svg/Calendar.svg");
export const camera = require("../../../../assets/svg/Camera.svg");
export const cardAccount = require("../../../../assets/svg/Card Account.svg");
export const cardActiveNative = require("../../../../assets/svg/Card Active Native.svg");
export const cardActive = require("../../../../assets/svg/Card Active.svg");
export const cardCancelSuspended = require("../../../../assets/svg/Card Cancel Suspended.svg");
export const cardInactiveNative = require("../../../../assets/svg/Card Inactive Native.svg");
export const cardInactive = require("../../../../assets/svg/Card Inactive.svg");
export const cardSuspended = require("../../../../assets/svg/Card Suspended.svg");
export const cardWeb = require("../../../../assets/svg/Card Web.svg");
export const card = require("../../../../assets/svg/Card.svg");
export const cards = require("../../../../assets/svg/Cards.svg");
export const changeATMPIN = require("../../../../assets/svg/Change ATM PIN.svg");
export const changePIN = require("../../../../assets/svg/Change PIN.svg");
export const checkBlue = require("../../../../assets/svg/Check Blue.svg");
export const checkCircleBlue = require("../../../../assets/svg/Check Circle Blue.svg");
export const checkCircleOutline = require("../../../../assets/svg/Check Circle Outline.svg");
export const checkCircle = require("../../../../assets/svg/Check Circle.svg");
export const checkOff = require("../../../../assets/svg/Check off.svg");
export const checkOn = require("../../../../assets/svg/Check on.svg");
export const check = require("../../../../assets/svg/Check.svg");
export const clearText = require("../../../../assets/svg/Clear Text.svg");
export const clockMenu = require("../../../../assets/svg/Clock Menu.svg");
export const clock = require("../../../../assets/svg/Clock.svg");
export const clock1 = require("../../../../assets/svg/Clock1.svg");
export const closeCircle = require("../../../../assets/svg/Close Circle.svg");
export const commoditiesInjection = require("../../../../assets/svg/Commodities Injection.svg");
export const copyWeb = require("../../../../assets/svg/Copy Web.svg");
export const copy = require("../../../../assets/svg/Copy.svg");
export const creditCard48 = require("../../../../assets/svg/Credit Card 48.svg");
export const creditCard = require("../../../../assets/svg/Credit Card.svg");
export const cross = require("../../../../assets/svg/Cross.svg");
export const customerservice = require("../../../../assets/svg/CustomerService.svg");
export const dot = require("../../../../assets/svg/DOT.svg");
export const dateArrow = require("../../../../assets/svg/Date Arrow.svg");
export const datePicker = require("../../../../assets/svg/Date Picker.svg");
export const deleteicon = require("../../../../assets/svg/DeleteIcon.svg");
export const deposit = require("../../../../assets/svg/Deposit.svg");
export const devDarkMode = require("../../../../assets/svg/Dev Dark Mode.svg");
export const devLightMode = require("../../../../assets/svg/Dev Light Mode.svg");
export const devSettings = require("../../../../assets/svg/Dev Settings.svg");
export const digitalAsset = require("../../../../assets/svg/Digital Asset.svg");
export const digitalDeposit = require("../../../../assets/svg/Digital Deposit.svg");
export const digitalInjection = require("../../../../assets/svg/Digital Injection.svg");
export const discoverActive = require("../../../../assets/svg/Discover Active.svg");
export const discoverBanner = require("../../../../assets/svg/Discover Banner.svg");
export const discoverDefi = require("../../../../assets/svg/Discover Defi.svg");
export const discoverFixedIncome = require("../../../../assets/svg/Discover Fixed Income.svg");
export const discoverGoldDeposit = require("../../../../assets/svg/Discover Gold Deposit.svg");
export const discoverHomeBannerNative = require("../../../../assets/svg/Discover Home Banner Native.svg");
export const discoverHomeBannerWeb = require("../../../../assets/svg/Discover Home Banner Web.svg");
export const discoverInactive = require("../../../../assets/svg/Discover Inactive.svg");
export const discoverLandingBackgroundPatternWeb = require("../../../../assets/svg/Discover Landing Background Pattern Web.svg");
export const discoverLending = require("../../../../assets/svg/Discover Lending.svg");
export const discoverStaking = require("../../../../assets/svg/Discover Staking.svg");
export const documentUploaded = require("../../../../assets/svg/Document Uploaded.svg");
export const dotsymbol = require("../../../../assets/svg/DotSymbol.svg");
export const dropdownCollapse = require("../../../../assets/svg/Dropdown Collapse.svg");
export const dropdownExpand = require("../../../../assets/svg/Dropdown Expand.svg");
export const eth = require("../../../../assets/svg/ETH.svg");
export const eur = require("../../../../assets/svg/EUR.svg");
export const earnBannerBG = require("../../../../assets/svg/Earn Banner BG.svg");
export const earnDefi = require("../../../../assets/svg/Earn Defi.svg");
export const earnFixedIncome = require("../../../../assets/svg/Earn Fixed Income.svg");
export const earnGold = require("../../../../assets/svg/Earn Gold.svg");
export const earnInvest = require("../../../../assets/svg/Earn Invest.svg");
export const earnLending = require("../../../../assets/svg/Earn Lending.svg");
export const earnNavDiscoverActive = require("../../../../assets/svg/Earn Nav Discover Active.svg");
export const earnNavDiscoverInactive = require("../../../../assets/svg/Earn Nav Discover Inactive.svg");
export const earnNavHistoryActive = require("../../../../assets/svg/Earn Nav History Active.svg");
export const earnNavHistoryInactive = require("../../../../assets/svg/Earn Nav History Inactive.svg");
export const earnNavPortfolioActive = require("../../../../assets/svg/Earn Nav Portfolio Active.svg");
export const earnNavPortfolioInactive = require("../../../../assets/svg/Earn Nav Portfolio Inactive.svg");
export const earnStaking = require("../../../../assets/svg/Earn Staking.svg");
export const edit = require("../../../../assets/svg/Edit.svg");
export const exchangeTo = require("../../../../assets/svg/Exchange To.svg");
export const exchangeUTGLNative = require("../../../../assets/svg/Exchange UTGL Native.svg");
export const exchangeUTGLWeb = require("../../../../assets/svg/Exchange UTGL Web.svg");
export const exchange = require("../../../../assets/svg/Exchange.svg");
export const exchangebp = require("../../../../assets/svg/ExchangeBP.svg");
export const exchangebanner = require("../../../../assets/svg/ExchangeBanner.svg");
export const exchangesymbol = require("../../../../assets/svg/ExchangeSymbol.svg");
export const exclamation = require("../../../../assets/svg/Exclamation.svg");
export const exportsymbol = require("../../../../assets/svg/ExportSymbol.svg");
export const facebook = require("../../../../assets/svg/Facebook.svg");
export const favourite40 = require("../../../../assets/svg/Favourite 40.svg");
export const favourite1 = require("../../../../assets/svg/Favourite-1.svg");
export const favourite = require("../../../../assets/svg/Favourite.svg");
export const fiatInjection = require("../../../../assets/svg/Fiat Injection.svg");
export const fileUploadError = require("../../../../assets/svg/File Upload Error.svg");
export const fileUploadSuccess = require("../../../../assets/svg/File Upload Success.svg");
export const fileUploadZeroState = require("../../../../assets/svg/File Upload Zero State.svg");
export const fileUploadedBackground = require("../../../../assets/svg/File Uploaded Background.svg");
export const fileUploading = require("../../../../assets/svg/File Uploading.svg");
export const filter1 = require("../../../../assets/svg/Filter-1.svg");
export const filter = require("../../../../assets/svg/Filter.svg");
export const food = require("../../../../assets/svg/Food.svg");
export const gbp = require("../../../../assets/svg/GBP.svg");
export const gold = require("../../../../assets/svg/Gold.svg");
export const google2FA = require("../../../../assets/svg/Google 2FA.svg");
export const hkd = require("../../../../assets/svg/HKD.svg");
export const help = require("../../../../assets/svg/Help.svg");
export const helpsymbol = require("../../../../assets/svg/HelpSymbol.svg");
export const hideUTGL = require("../../../../assets/svg/Hide UTGL.svg");
export const hide = require("../../../../assets/svg/Hide.svg");
export const historyCalendar = require("../../../../assets/svg/History Calendar.svg");
export const history = require("../../../../assets/svg/History.svg");
export const homeActive = require("../../../../assets/svg/Home Active.svg");
export const homeInactive = require("../../../../assets/svg/Home Inactive.svg");
export const horizontalDot = require("../../../../assets/svg/Horizontal Dot.svg");
export const idBack = require("../../../../assets/svg/ID Back.svg");
export const idFront = require("../../../../assets/svg/ID Front.svg");
export const iconSymbol = require("../../../../assets/svg/Icon Symbol.svg");
export const infoCircle = require("../../../../assets/svg/Info Circle.svg");
export const infoNative = require("../../../../assets/svg/Info Native.svg");
export const info = require("../../../../assets/svg/Info.svg");
export const injectUTGLNative = require("../../../../assets/svg/Inject UTGL Native.svg");
export const injectUTGLWeb = require("../../../../assets/svg/Inject UTGL web.svg");
export const inject = require("../../../../assets/svg/Inject.svg");
export const intructionHistory = require("../../../../assets/svg/Intruction History.svg");
export const investment = require("../../../../assets/svg/Investment.svg");
export const investmentbp = require("../../../../assets/svg/InvestmentBP.svg");
export const link = require("../../../../assets/svg/LINK.svg");
export const landingPageNative = require("../../../../assets/svg/Landing Page Native.svg");
export const landingPageWeb = require("../../../../assets/svg/Landing Page Web.svg");
export const landingPage = require("../../../../assets/svg/Landing Page.svg");
export const landingbpshadow = require("../../../../assets/svg/LandingBPShadow.svg");
export const landingbpshadowmobile = require("../../../../assets/svg/LandingBPShadowMobile.svg");
export const language = require("../../../../assets/svg/Language.svg");
export const lastUpdated = require("../../../../assets/svg/Last Updated.svg");
export const letter = require("../../../../assets/svg/Letter.svg");
export const letter2 = require("../../../../assets/svg/Letter2.svg");
export const level1 = require("../../../../assets/svg/Level 1.svg");
export const level2 = require("../../../../assets/svg/Level 2.svg");
export const limit = require("../../../../assets/svg/Limit.svg");
export const listZeroState = require("../../../../assets/svg/List Zero State.svg");
export const loading = require("../../../../assets/svg/Loading.svg");
export const lockUTGLNative = require("../../../../assets/svg/Lock UTGL Native.svg");
export const lockUTGLWeb = require("../../../../assets/svg/Lock UTGL Web.svg");
export const lock1 = require("../../../../assets/svg/Lock-1.svg");
export const lock = require("../../../../assets/svg/Lock.svg");
export const locked = require("../../../../assets/svg/Locked.svg");
export const loginDetail = require("../../../../assets/svg/Login Detail.svg");
export const logout = require("../../../../assets/svg/Logout.svg");
export const maintenance = require("../../../../assets/svg/Maintenance.svg");
export const maintenancebp = require("../../../../assets/svg/MaintenanceBP.svg");
export const map = require("../../../../assets/svg/Map.svg");
export const mastercard = require("../../../../assets/svg/Mastercard.svg");
export const minus = require("../../../../assets/svg/Minus.svg");
export const moreNative = require("../../../../assets/svg/More Native.svg");
export const moreV = require("../../../../assets/svg/More V.svg");
export const more = require("../../../../assets/svg/More.svg");
export const moresymbol = require("../../../../assets/svg/MoreSymbol.svg");
export const moveTop = require("../../../../assets/svg/Move Top.svg");
export const navClose = require("../../../../assets/svg/Nav Close.svg");
export const navDiscoverInactive = require("../../../../assets/svg/Nav Discover Inactive.svg");
export const navDiscover = require("../../../../assets/svg/Nav Discover.svg");
export const navHistory = require("../../../../assets/svg/Nav History.svg");
export const navPortfolio = require("../../../../assets/svg/Nav Portfolio.svg");
export const note = require("../../../../assets/svg/Note.svg");
export const notice = require("../../../../assets/svg/Notice.svg");
export const notificationSetting = require("../../../../assets/svg/Notification Setting.svg");
export const notification = require("../../../../assets/svg/Notification.svg");
export const online = require("../../../../assets/svg/Online.svg");
export const others = require("../../../../assets/svg/Others.svg");
export const overseabp = require("../../../../assets/svg/OverseaBP.svg");
export const oversealocalbp = require("../../../../assets/svg/OverseaLocalBP.svg");
export const pax = require("../../../../assets/svg/PAX.svg");
export const pdf = require("../../../../assets/svg/PDF.svg");
export const palladium = require("../../../../assets/svg/Palladium.svg");
export const passport = require("../../../../assets/svg/Passport.svg");
export const paste = require("../../../../assets/svg/Paste.svg");
export const paymentMenu = require("../../../../assets/svg/Payment Menu.svg");
export const payment = require("../../../../assets/svg/Payment.svg");
export const paymentsymbol = require("../../../../assets/svg/PaymentSymbol.svg");
export const pieChart = require("../../../../assets/svg/Pie Chart.svg");
export const pinUTGLNative = require("../../../../assets/svg/Pin UTGL Native.svg");
export const pinUTGLWeb = require("../../../../assets/svg/Pin UTGL Web.svg");
export const placeholderDark20 = require("../../../../assets/svg/Placeholder Dark 20.svg");
export const placeholderDark24 = require("../../../../assets/svg/Placeholder Dark 24.svg");
export const placeholderLight20 = require("../../../../assets/svg/Placeholder Light 20.svg");
export const placeholderLight24 = require("../../../../assets/svg/Placeholder Light 24.svg");
export const platinum = require("../../../../assets/svg/Platinum.svg");
export const plus = require("../../../../assets/svg/Plus.svg");
export const popup = require("../../../../assets/svg/Popup.svg");
export const post = require("../../../../assets/svg/Post.svg");
export const profile40 = require("../../../../assets/svg/Profile 40.svg");
export const profile = require("../../../../assets/svg/Profile.svg");
export const purchaseLimit = require("../../../../assets/svg/Purchase Limit.svg");
export const rmb = require("../../../../assets/svg/RMB.svg");
export const recentTrade = require("../../../../assets/svg/Recent Trade.svg");
export const referral = require("../../../../assets/svg/Referral.svg");
export const refresh = require("../../../../assets/svg/Refresh.svg");
export const removeEdit = require("../../../../assets/svg/Remove Edit.svg");
export const remove = require("../../../../assets/svg/Remove.svg");
export const replaceCard = require("../../../../assets/svg/Replace Card.svg");
export const replaceUTGLNative = require("../../../../assets/svg/Replace UTGL Native.svg");
export const replaceUTGLWeb = require("../../../../assets/svg/Replace UTGL Web.svg");
export const requestPayment = require("../../../../assets/svg/Request Payment.svg");
export const reset = require("../../../../assets/svg/Reset.svg");
export const rightIcon = require("../../../../assets/svg/Right Icon.svg");
export const sgd = require("../../../../assets/svg/SGD.svg");
export const sms2FA = require("../../../../assets/svg/SMS 2FA.svg");
export const sample = require("../../../../assets/svg/Sample.svg");
export const save = require("../../../../assets/svg/Save.svg");
export const scan = require("../../../../assets/svg/Scan.svg");
export const search = require("../../../../assets/svg/Search.svg");
export const selfie = require("../../../../assets/svg/Selfie.svg");
export const send = require("../../../../assets/svg/Send.svg");
export const settingUTGLNative = require("../../../../assets/svg/Setting UTGL Native.svg");
export const settingUTGLWeb = require("../../../../assets/svg/Setting UTGL Web.svg");
export const setting = require("../../../../assets/svg/Setting.svg");
export const shopping = require("../../../../assets/svg/Shopping.svg");
export const showAllCard = require("../../../../assets/svg/Show All Card.svg");
export const showUTGL = require("../../../../assets/svg/Show UTGL.svg");
export const show = require("../../../../assets/svg/Show.svg");
export const signIn2FA = require("../../../../assets/svg/Sign in 2FA.svg");
export const signature = require("../../../../assets/svg/Signature.svg");
export const silver = require("../../../../assets/svg/Silver.svg");
export const sort = require("../../../../assets/svg/Sort.svg");
export const starOff = require("../../../../assets/svg/Star off.svg");
export const starOn = require("../../../../assets/svg/Star on.svg");
export const statement = require("../../../../assets/svg/Statement.svg");
export const stepTwo = require("../../../../assets/svg/Step Two.svg");
export const submitted = require("../../../../assets/svg/Submitted.svg");
export const success2 = require("../../../../assets/svg/Success 2.svg");
export const successSpecial = require("../../../../assets/svg/Success Special.svg");
export const success = require("../../../../assets/svg/Success.svg");
export const successexchange = require("../../../../assets/svg/SuccessExchange.svg");
export const swap40 = require("../../../../assets/svg/Swap 40.svg");
export const swapAccount = require("../../../../assets/svg/Swap Account.svg");
export const swapTrade = require("../../../../assets/svg/Swap Trade.svg");
export const swap = require("../../../../assets/svg/Swap.svg");
export const swipe = require("../../../../assets/svg/Swipe.svg");
export const switchAccount = require("../../../../assets/svg/Switch Account.svg");
export const switchicon = require("../../../../assets/svg/SwitchIcon.svg");
export const tagApy = require("../../../../assets/svg/Tag Apy.svg");
export const tagMaturity = require("../../../../assets/svg/Tag Maturity.svg");
export const telegram = require("../../../../assets/svg/Telegram.svg");
export const to = require("../../../../assets/svg/To.svg");
export const topUp = require("../../../../assets/svg/Top Up.svg");
export const trackingOff = require("../../../../assets/svg/Tracking Off.svg");
export const trackingOn = require("../../../../assets/svg/Tracking On.svg");
export const tradePair = require("../../../../assets/svg/Trade Pair.svg");
export const transferUTGLNative = require("../../../../assets/svg/Transfer UTGL Native.svg");
export const transferUTGLWeb = require("../../../../assets/svg/Transfer UTGL Web.svg");
export const transfer = require("../../../../assets/svg/Transfer.svg");
export const transferbp = require("../../../../assets/svg/TransferBP.svg");
export const transportation = require("../../../../assets/svg/Transportation.svg");
export const travel = require("../../../../assets/svg/Travel.svg");
export const trustOverviewMenu = require("../../../../assets/svg/Trust Overview Menu.svg");
export const trustOverview = require("../../../../assets/svg/Trust Overview.svg");
export const twitter = require("../../../../assets/svg/Twitter.svg");
export const usd = require("../../../../assets/svg/USD.svg");
export const usdc = require("../../../../assets/svg/USDC.svg");
export const usdt = require("../../../../assets/svg/USDT.svg");
export const utglEarn = require("../../../../assets/svg/UTGL Earn.svg");
export const unionPayBP = require("../../../../assets/svg/Union Pay BP.svg");
export const unlockUTGLWeb = require("../../../../assets/svg/Unlock UTGL Web.svg");
export const unlock = require("../../../../assets/svg/Unlock.svg");
export const updateMobileNumberNative = require("../../../../assets/svg/Update Mobile Number Native.svg");
export const updateMobileNumberUTGL = require("../../../../assets/svg/Update Mobile Number UTGL.svg");
export const updateMobileNumberWeb = require("../../../../assets/svg/Update Mobile Number Web.svg");
export const upgrade = require("../../../../assets/svg/Upgrade.svg");
export const uploadDocumentZeroState = require("../../../../assets/svg/Upload Document Zero State.svg");
export const upload = require("../../../../assets/svg/Upload.svg");
export const upload2 = require("../../../../assets/svg/Upload2.svg");
export const video = require("../../../../assets/svg/Video.svg");
export const withdrawMobile = require("../../../../assets/svg/Withdraw Mobile.svg");
export const withdrawUTGLNative = require("../../../../assets/svg/Withdraw UTGL Native.svg");
export const withdrawUTGLWeb = require("../../../../assets/svg/Withdraw UTGL Web.svg");
export const withdraw = require("../../../../assets/svg/Withdraw.svg");
export const worldEliteIcon = require("../../../../assets/svg/World Elite Icon.svg");
export const zeroState = require("../../../../assets/svg/Zero State.svg");
export const zero = require("../../../../assets/svg/Zero.svg");
export const banner_pattern = require("../../../../assets/svg/banner_pattern.svg");
export const banner_text = require("../../../../assets/svg/banner_text.svg");
export const exchangeSubAccountBg = require("../../../../assets/svg/exchange-sub-account-bg.svg");
export const right_graphic = require("../../../../assets/svg/right_graphic.svg");
export const tenor = require("../../../../assets/svg/tenor.svg");
export const utglTitle = require("../../../../assets/svg/utgl title.svg");